import React, { Component, Fragment } from "react";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import NumberFormat from "react-number-format";
import KurdishSoraniNumbersToWords from "kurdish-numbers-to-words/Sorani.js";
import n2wordsEN from "n2words/lib/i18n/AR.mjs";
export class PrintViewTakemoney extends Component {
 render() {
  const {
   change_Lang,
   take_money_view,
   primary_logo_bill,
   lang,
   footer_logo_bill,
  } = this.props;
  let numberWordsSorani =
   take_money_view.Amount !== ""
    ? KurdishSoraniNumbersToWords.convert(take_money_view.Amount)
    : 0;
  let numWords1 =
   take_money_view.Amount !== undefined && take_money_view.Amount !== null
    ? n2wordsEN(parseFloat(take_money_view.Amount.toString().replace(/,/g, "")))
    : 0;
  return (
   <Fragment>
    <div class="card product-page-main card-body">
     <div class="card-body p-0" id="yy">
      <div className="fk">
       <div class="row">
        <div class="col-12  ">
         <img
          src={primary_logo_bill}
          alt="logo"
          className="img-fluid img-responsive"
          style={{
           position: "relative",
           top: -15,
           width: "100%",
          }}
         />
        </div>
       </div>

       <div class="row">
        <div class="col-3">
         <p
          style={{
           fontSize: "22px",
           color: "#2e425d",
           textAlign: "right",
           fontWeight: "bold",
          }}
          class=" text-uppercase"
         >
          &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
          <Time
           value={take_money_view.createdAt}
           format="YYYY-MM-DD"
           style={{
            fontSize: "22px",
            color: "#2e425d",
            fontWeight: "bold",
           }}
          />
         </p>
        </div>
        <div class="col-6 d-flex justify-content-center">
         <p
          style={{
           fontSize: "24px",
           color: "#2e425d",
           fontWeight: "bolder",
          }}
          class={`d-flex justify-content-center text-uppercase ${
           lang !== "en" ? "fk" : "fkp"
          } `}
         >
          {change_Lang("Repayment bills")} ({change_Lang(take_money_view.type)})
         </p>
        </div>
        <div class="col-3 text-right">
         <p
          style={{
           fontSize: "22px",
           color: "#2e425d",
           fontWeight: "bold",
          }}
          class=" text-uppercase"
         >
          {change_Lang("in_invoice")}#&nbsp;
          {take_money_view.invoice_No}&nbsp;
         </p>
        </div>
       </div>
       {/* first row */}
       <div
        class="row mt-3"
        style={{ width: "100%", backgroundColor: "#f4f4f6" }}
       >
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          وەرگر/المستلم :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <label
          className="fk col-form-label d-flex justify-content-start"
          style={{
           fontSize: "18px",
           color: "black",
          }}
         >
          {take_money_view.Money_recive}
         </label>
        </div>
        <div class="col-3 d-flex justify-content-end">
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fkb"
         >
          : Receipt from
         </label>
        </div>
       </div>
       {/* second row */}
       <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          بڕی پارە / مبلغ و قدره :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <span className="fk" style={{ fontWeight: "bold", marginTop: "12px" }}>
          {change_Lang("Only")}
         </span>
         &nbsp;
         <NumberFormat
          displayType="text"
          thousandSeparator={true}
          value={take_money_view.Amount}
          style={{
           fontSize: "20px",
           color: "black",
          }}
          className="col-form-label"
          prefix={`${take_money_view.currency === "dolar" ? "$" : "ID"}`}
         />
         &nbsp;&nbsp;
         <span className="fk" style={{ fontWeight: "bold", marginTop: "12px" }}>
          {" "}
          {lang === "krd" ? numberWordsSorani : numWords1}&nbsp;
          {`${
           take_money_view.currency === "dolar" ? "دۆلاری ئەمریکی" : "دینار"
          }`}
         </span>
        </div>
        <div class="col-3 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fkb"
         >
          : Amount
         </label>
        </div>
       </div>
       {/* third row */}
       <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          لە بڕی / وذلك عن :
         </label>
        </div>
        <div class="col-8 d-flex justify-content-center">
         {take_money_view.type !== "investor" &&
         take_money_view.instead_of === "" ? (
          <span
           className="fk d-flex justify-content-center mt-2"
           style={{
            fontSize: "16px",
            color: "black",
            textAlign: "justify",
           }}
          >
           {take_money_view.type !== "Monthly rent invoice" ? (
            <>
             {change_Lang(take_money_view.type)} (
             {change_Lang(take_money_view.property)})&nbsp;
             {change_Lang("from")}
             &nbsp;({take_money_view.place}) &nbsp;
             {change_Lang("Number")}&nbsp;({take_money_view.num})
            </>
           ) : (
            <>
             {change_Lang(take_money_view.type)} (
             {change_Lang(take_money_view.property)})&nbsp;
             {change_Lang("from")}
             &nbsp;({take_money_view.place}) &nbsp;
             {change_Lang("Number")}&nbsp;({take_money_view.num}
             )&nbsp;
             {change_Lang("from")}&nbsp;
             {take_money_view.from}
             &nbsp;
             {change_Lang("to")}&nbsp;
             {take_money_view.to}
            </>
           )}
          </span>
         ) : (
          <span
           className="fk d-flex justify-content-center mt-2"
           style={{
            fontSize: "16px",
            color: "black",
            textAlign: "justify",
           }}
          >
           {take_money_view && take_money_view.instead_of}
          </span>
         )}
        </div>
        <div class="col-1 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fkb"
         >
          : For
         </label>
        </div>
       </div>
       {/* five row */}
       <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          پارەدەر / الدافع :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <label
          className="fk col-form-label"
          style={{
           fontSize: "18px",
           color: "black",
          }}
         >
          {take_money_view.Money_provider}
         </label>
        </div>
        <div class="col-3 d-flex justify-content-end">
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label"
         >
          : Receptor
         </label>
        </div>
       </div>
       {/* note */}
       <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          تێبینی / الملاحظات :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <label
          className="fk col-form-label"
          style={{
           fontSize: "18px",
           color: "black",
          }}
         >
          {take_money_view.note}
         </label>
        </div>
        <div class="col-3 d-flex justify-content-end">
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label"
         >
          : Note
         </label>
        </div>
       </div>
       {/* six row */}
       <br />
       <br />
       <div class="row">
        <div class="col-6 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          (پارەدەر)&nbsp;واژوو / توقيع
         </label>
        </div>
        <div class="col-6 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          (پارەوەرگر)&nbsp;واژوو / توقيع
         </label>
        </div>
        <div class="col-6 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
           fontWeight: "bold",
          }}
          class=" col-form-label fk"
         >
          {take_money_view.Money_provider}
         </label>
        </div>
        <div class="col-6 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
           fontWeight: "bold",
          }}
          class=" col-form-label fk"
         >
          {take_money_view.Money_recive}
         </label>
        </div>
       </div>
       <br />
       {/* footer */}
       <div
        className="row"
        style={{
         width: "100%",
         marginLeft: "20px",
        }}
       >
        <div className="col-12">
         <img src={footer_logo_bill} alt="logo" width="100%" />
        </div>
       </div>
      </div>
      <br />
      <hr style={{ border: "1px dashed black" }} />
      <br />
      {/* Second Invoice */}
      <div className="fk">
       <div class="row">
        <div class="col-12  ">
         <img
          src={primary_logo_bill}
          alt="logo"
          className="img-fluid img-responsive"
          style={{
           position: "relative",
           top: -15,
           width: "100%",
          }}
         />
        </div>
       </div>

       <div class="row">
        <div class="col-3">
         <p
          style={{
           fontSize: "22px",
           color: "#2e425d",
           textAlign: "right",
           fontWeight: "bold",
          }}
          class=" text-uppercase"
         >
          &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
          <Time
           value={take_money_view.createdAt}
           format="YYYY-MM-DD"
           style={{
            fontSize: "22px",
            color: "#2e425d",
            fontWeight: "bold",
           }}
          />
         </p>
        </div>
        <div class="col-6 d-flex justify-content-center">
         <p
          style={{
           fontSize: "24px",
           color: "#2e425d",
           fontWeight: "bolder",
          }}
          class={`d-flex justify-content-center text-uppercase ${
           lang !== "en" ? "fk" : "fkp"
          } `}
         >
          {change_Lang("Repayment bills")} ({change_Lang(take_money_view.type)})
         </p>
        </div>
        <div class="col-3 text-right">
         <p
          style={{
           fontSize: "22px",
           color: "#2e425d",
           fontWeight: "bold",
          }}
          class=" text-uppercase"
         >
          {change_Lang("in_invoice")}#&nbsp;
          {take_money_view.invoice_No}&nbsp;
         </p>
        </div>
       </div>
       {/* first row */}
       <div
        class="row mt-3"
        style={{ width: "100%", backgroundColor: "#f4f4f6" }}
       >
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          وەرگر/المستلم :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <label
          className="fk col-form-label d-flex justify-content-start"
          style={{
           fontSize: "18px",
           color: "black",
          }}
         >
          {take_money_view.Money_recive}
         </label>
        </div>
        <div class="col-3 d-flex justify-content-end">
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fkb"
         >
          : Receipt from
         </label>
        </div>
       </div>
       {/* second row */}
       <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          بڕی پارە / مبلغ و قدره :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <span className="fk" style={{ fontWeight: "bold", marginTop: "12px" }}>
          {change_Lang("Only")}
         </span>
         &nbsp;
         <NumberFormat
          displayType="text"
          thousandSeparator={true}
          value={take_money_view.Amount}
          style={{
           fontSize: "20px",
           color: "black",
          }}
          className="col-form-label"
          prefix={`${take_money_view.currency === "dolar" ? "$" : "ID"}`}
         />
         &nbsp;&nbsp;
         <span className="fk" style={{ fontWeight: "bold", marginTop: "12px" }}>
          {" "}
          {lang === "krd" ? numberWordsSorani : numWords1}&nbsp;
          {`${
           take_money_view.currency === "dolar" ? "دۆلاری ئەمریکی" : "دینار"
          }`}
         </span>
        </div>
        <div class="col-3 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fkb"
         >
          : Amount
         </label>
        </div>
       </div>
       {/* third row */}
       <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          لە بڕی / وذلك عن :
         </label>
        </div>
        <div class="col-8 d-flex justify-content-center">
         {take_money_view.type !== "investor" &&
         take_money_view.instead_of === "" ? (
          <span
           className="fk d-flex justify-content-center mt-2"
           style={{
            fontSize: "16px",
            color: "black",
            textAlign: "justify",
           }}
          >
           {take_money_view.type !== "Monthly rent invoice" ? (
            <>
             {change_Lang(take_money_view.type)} (
             {change_Lang(take_money_view.property)})&nbsp;
             {change_Lang("from")}
             &nbsp;({take_money_view.place}) &nbsp;
             {change_Lang("Number")}&nbsp;({take_money_view.num})
            </>
           ) : (
            <>
             {change_Lang(take_money_view.type)} (
             {change_Lang(take_money_view.property)})&nbsp;
             {change_Lang("from")}
             &nbsp;({take_money_view.place}) &nbsp;
             {change_Lang("Number")}&nbsp;({take_money_view.num}
             )&nbsp;
             {change_Lang("from")}&nbsp;
             {take_money_view.from}
             &nbsp;
             {change_Lang("to")}&nbsp;
             {take_money_view.to}
            </>
           )}
          </span>
         ) : (
          <span
           className="fk d-flex justify-content-center mt-2"
           style={{
            fontSize: "16px",
            color: "black",
            textAlign: "justify",
           }}
          >
           {take_money_view && take_money_view.instead_of}
          </span>
         )}
        </div>
        <div class="col-1 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fkb"
         >
          : For
         </label>
        </div>
       </div>
       {/* five row */}
       <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          پارەدەر / الدافع :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <label
          className="fk col-form-label"
          style={{
           fontSize: "18px",
           color: "black",
          }}
         >
          {take_money_view.Money_provider}
         </label>
        </div>
        <div class="col-3 d-flex justify-content-end">
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label"
         >
          : Receptor
         </label>
        </div>
       </div>
       {/* note */}
       <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
        <div class="col-3 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          تێبینی / الملاحظات :
         </label>
        </div>
        <div class="col-6 d-flex justify-content-center">
         {" "}
         <label
          className="fk col-form-label"
          style={{
           fontSize: "18px",
           color: "black",
          }}
         >
          {take_money_view.note}
         </label>
        </div>
        <div class="col-3 d-flex justify-content-end">
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label"
         >
          : Note
         </label>
        </div>
       </div>
       {/* six row */}
       <br />
       <br />
       <div class="row">
        <div class="col-6 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          (پارەدەر)&nbsp;واژوو / توقيع
         </label>
        </div>
        <div class="col-6 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "20px",
           color: "black",
          }}
          class=" col-form-label fk"
         >
          (پارەوەرگر)&nbsp;واژوو / توقيع
         </label>
        </div>
        <div class="col-6 d-flex justify-content-start">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
           fontWeight: "bold",
          }}
          class=" col-form-label fk"
         >
          {take_money_view.Money_provider}
         </label>
        </div>
        <div class="col-6 d-flex justify-content-end">
         {" "}
         <label
          style={{
           fontSize: "18px",
           color: "black",
           fontWeight: "bold",
          }}
          class=" col-form-label fk"
         >
          {take_money_view.Money_recive}
         </label>
        </div>
       </div>
       <br />
       {/* footer */}
       <div
        className="row"
        style={{
         position: "fixed",
         bottom: 0,
         width: "100%",
         marginLeft: "20px",
        }}
       >
        <div className="col-12">
         <img src={footer_logo_bill} alt="logo" width="100%" />
        </div>
       </div>
      </div>
     </div>
    </div>
   </Fragment>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  take_money_view: state.Invoice_Reducer.take_money_view,
  index_takemoney: state.Invoice_Reducer.index_takemoney,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  primary_logo_bill: state.HelperReducer.primary_logo_bill,
  footer_logo_bill: state.HelperReducer.footer_logo_bill,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintViewTakemoney);
